import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MenuHasSubItemsPipe } from '@components/header/menu/pipes';
import { buildNavigationJsonLd } from '@components/header/utils';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgComponent } from '@shared/components/svg';
import { Menu } from '@shared/models';
import { LanguageService } from '@shared/services/language';
import { SeoService } from '@shared/services/seo';

@Component({
  selector: 'app-menu-blog',
  templateUrl: './menu-blog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MenuHasSubItemsPipe, SvgComponent, RouterLink, RouterLinkActive, NgClass, TranslatePipe],
})
export class MenuBlogComponent implements OnInit, OnDestroy {
  menuBlog = input.required<Menu>();
  protected readonly isCategoriesMenuOpen = signal(false);
  protected readonly categoriesToDisplay = signal<boolean[]>([]);
  protected readonly subMenuColor = computed(() => {
    if (this.menuBlog()?.subMenuColor === 'purple') {
      return 'purple';
    } else {
      return 'blue';
    }
  });
  private readonly seoService = inject(SeoService);
  private readonly languageService = inject(LanguageService);

  constructor() {
    effect(() => {
      if (!this.isCategoriesMenuOpen()) {
        this.categoriesToDisplay.set(this.menuBlog().categories.map(() => true));
      }
    });

    effect(() => {
      const menu = this.menuBlog();
      if (menu) {
        const menuSchemaJsonLd = buildNavigationJsonLd(this.languageService.instant('SCHEMA_JSON_LD.BLOG_MENU'), menu);
        if (menuSchemaJsonLd) this.seoService.addJsonLdScript('blog-menu', menuSchemaJsonLd);
      }
    });
  }

  ngOnInit() {
    this.categoriesToDisplay.set(this.menuBlog().categories.map(() => true));
  }

  ngOnDestroy() {
    this.seoService.removeJsonLdScript('blog-menu');
  }

  toggleCategories() {
    this.isCategoriesMenuOpen.update((v) => !v);
  }

  toggleCategory(index: number) {
    this.categoriesToDisplay.update((categoriesToDisplay) => {
      categoriesToDisplay[index] = !categoriesToDisplay[index];
      return categoriesToDisplay;
    });
  }
}
